import React from 'react';

import type { ButtonIcon } from '@motorway/mw-highway-code';
import { Button } from '@motorway/mw-highway-code';

import { applyCypressData } from 'Utilities/helpers';

interface SimilarVehiclesCarouselArrowProps {
	className?: string;
	containerCypressId?: string;
	icon: ButtonIcon;
	label: string;
	onClick?: () => void;
	style?: React.CSSProperties;
}

export const slickSliderArrowButtonIsDisabled = (className?: string): boolean =>
	className?.includes('slick-disabled') ?? false;

export const SimilarVehiclesCarouselArrow: React.FC<SimilarVehiclesCarouselArrowProps> = ({
	className,
	containerCypressId,
	icon,
	label,
	onClick,
	style,
}) => {
	return (
		<div className={className} style={style} {...applyCypressData(containerCypressId)}>
			<Button
				disabled={slickSliderArrowButtonIsDisabled(className)}
				icon={icon}
				label={label}
				onClick={onClick}
				showLabel={false}
				tabIndex={-1}
				variant="secondary"
			/>
		</div>
	);
};
